import { Injectable } from '@angular/core';
import { livechat } from '../../../libs/livechat_ref.js';
import { log } from 'util';
import { Router, NavigationExtras } from '@angular/router';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { MessengerService } from '../messenger/messenger.service';
import { CommunicationInterfaceService } from '../communicationInterface/communication-interface.service';
import { AppdataService } from '../app-data/appdata.service';

@Injectable({
  providedIn: 'root'
})
export class ChatqueueService {
  // queue postion text with queue count
  // queuePosText: string = '';
  queuePos: number;

  private queuePosText = new BehaviorSubject<any>({ queueText: '', queueNumber: 0 });
  private queuePosNumber = new Subject<any>();

  cast: Observable<any> = this.queuePosText.asObservable();
  queueData: Observable<any> = this.queuePosNumber.asObservable();

  private toggleQueue = new Subject<any>();
  toggleQueueObservable: Observable<any> = this.toggleQueue.asObservable();
  
  updateQueueVideo = new Subject<any>();
  observeUpdateQueueVideo: Observable<any> = this.updateQueueVideo.asObservable();

  queueVideo:String;

  constructor(private route: Router, private messengerService: MessengerService, private commInterface: CommunicationInterfaceService, appDataService: AppdataService) {
    console.log('%c ChatqueueService', 'color:white; background: blue;');
    appDataService.appConfigSub.subscribe((config) => {
      if (!config) {
        return;
      }
      this.commInterface.registerCallbackEvents();
    });
    
  }

  updateQueuePostionText(text: string) {
    // update the text only once
    let queueMsg = {
      queueText: text,
      queueNumber: this.queuePos
    };
    console.log(queueMsg);
    this.queuePosText.next(queueMsg);
    this.sendQposData(this.queuePos);
  }

  updateQueueNumberandImage(queueText: string, queueImg: string, queueNo: string, agentTransferText: any) {
    this.queuePosNumber.next({ queueText, queueImg, queueNo, agentTransferText });
  }

  toggleQueueOverlay(isOpen) {
    this.toggleQueue.next(isOpen);
  }

  sendQposData(queueNo: number | any): void {
    try {
      const queuePositionResponse = {
        MessageId: null,
        InputType: "action",
        OptionId: "qpos",
        Response: JSON.stringify({
          "key": "qpos",
          "value": queueNo
        })
      }
      this.commInterface.sendAppMessage(JSON.stringify(queuePositionResponse));
    } catch (error) {
      console.error(error)
    }
  }
}
